import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {fetchSingleIfNeeded} from '../actions/apps-by-type';
import {FormattedMessage} from 'react-intl';
import AppBoxCollecion from '../components/App-box-collection';
import ErrorMessage from '../components/Error-message';

class OpenApps extends React.Component {

  static fetchData(dispatch, params, location) {
    if (location.query.ids) {
      return dispatch(fetchSingleIfNeeded(location.query.ids.split(',')));
    }
  }

  render() {
    const apps = this.props.items;
    const appName = apps.length ? apps[0].name : '';

    return (
      <div className="short-header-page secondary-inner-page">

        {!apps.length && !this.props.isFetching ? <ErrorMessage/> : ''}

        <div className="section section-pad section-vertical-pad">
          <h1 className="title">
            <span className="typography_h1">
              <FormattedMessage id="search.single" values={{appName}}/>
            </span>
          </h1>
        </div>

        {this.props.isFetching ?
          <div className="circle-loader"></div> : ''}

        <div className="app-box-grid section section-pad-left">
          {apps.map((app, i) =>
            <div className="col col-1-4" key={app.slug}>
              <AppBoxCollecion app={app} reviews={this.props.reviews} biPosition={i + 1}/>
            </div>
          )}
        </div>

      </div>
    );
  }
}

OpenApps.propTypes = {
  items: PropTypes.array.isRequired,
  reviews: PropTypes.object,
  params: PropTypes.object,
  dispatch: PropTypes.func,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool
};


function mapStateToProps(state) {
  return {
    items: state.appsByType.single.items,
    reviews: state.reviews.all
  };
}

export default connect(mapStateToProps)(OpenApps);



// WEBPACK FOOTER //
// ./containers/Open-apps.js